<div mat-dialog-title>
  <div class="title-container">
    <div class="title-modal d-flex f-align-center"></div>
  </div>

  <div mat-dialog-content>
    <div class="content-container">
      <img [src]="srcImg" alt="success" />
      <span class="description"> Permission {{ data.action === 'create' ? 'created' : 'deleted' }} successfully. </span>
    </div>
  </div>

  <div mat-dialog-actions>
    <button class="rp-button rp-filled rp-primary" (click)="close()">Got it</button>
  </div>
</div>
